export default __webpack_public_path__ + "assets/home-three-one.0ea47d18c8f85cebbfa0bc1270f2fbb7.png";